import { useMutation } from '@tanstack/react-query';
import API from 'util/API';
import moment from 'moment';

/**
 * Custom hook for fetching public holidays
 * Uses react-query for state management and caching
 */
export const usePublicHolidays = () => {
  return useMutation({
    mutationFn: async () => {
      // Server returns admin-maintained holidays (source "settings") before the API cache
      const response = await API.get("/publicHolidays").catch((error) => {
        const serverMessage = error.response && error.response.data && error.response.data.error;
        throw serverMessage ? new Error(serverMessage) : error;
      });

      // Extract holidays from response
      const holidays = response.data.data || [];
      
      if (!Array.isArray(holidays) || holidays.length === 0) {
        throw new Error("No public holidays found");
      }
      
      // Convert dates from YYYY-MM-DD format to the format we need
      const holidayDates = holidays.map(holiday => {
        return moment(holiday.date).format("DD/MM/YYYY");
      });
      
      return holidayDates;
    },
    retry: 2,
  });
};

